import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import { isResidentRole, isStaffRole } from '../../../../utils';

const VisibleToComponent = ({ personRoleId, isMultiThread }) => {
  const { t } = useTransl();
  let visibleTo = null;
  const isSenderStaff = personRoleId && isStaffRole(personRoleId);
  const isSenderResident = personRoleId && isResidentRole(personRoleId);
  if (isSenderStaff) visibleTo = t('messages.visibleToAll');
  if (isSenderResident) visibleTo = t('messages.visibleToStaff');
  return isMultiThread && visibleTo ? <div>{visibleTo}</div> : null;
};

VisibleToComponent.defaultProps = {
  personRoleId: null,
};

VisibleToComponent.propTypes = {
  personRoleId: PropTypes.instanceOf(Object),
  isMultiThread: PropTypes.bool.isRequired,
};

export default VisibleToComponent;
